<template>
    <div class="page bg-fff text-center">
        <backTitleBar :isBackClose="true" :isLogOut="true"></backTitleBar>
        <img :src="mainImg" alt="" class="main-img">
        <div class="fs-36 color-333 mt-25 font-bold">审核失败</div>
        <div class="fs-28 color-999 mt-20">
            请重新提交修改数据<br/>
            <span class="color-red">失败原因：{{reason}}</span>
        </div>
        <div class="btn" @click="backToEdit">
            重新提交
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import getAppParams from "@/mixins/getAppParams"
    export default {
        name: "checkError",
        components:{backTitleBar},
        mixins:[getAppParams],
        data(){
            return{
                mainImg: require("../../../assets/images/shopRegister/checkError.png"),
                reason:''
            }
        },
        created() {
            if(this.$route.query.reason){
                this.reason = this.$route.query.reason;
            }
        },
        methods:{
            backToEdit(){
                this.$router.push({name: 'shopRegisterBaseInfo'});
            },
        }
    }
</script>

<style scoped lang="scss">
    .main-img{
        width: 1.28rem;
        height: 1.28rem;
        margin-top: 1.4rem;
    }
    .btn{
        width: 2.8rem;
        height: .88rem;
        line-height: .88rem;
        text-align: center;
        background: #F4F4F4;
        border-radius: .12rem;
        color: $main-color;
        font-size: .34rem;
        margin: 5rem auto 0;
    }
</style>



// WEBPACK FOOTER //
// checkError.vue?7029cf84